<template>
  <div>
    <a href="/kirjaudu">Login</a>
    <br />
    <a href="/kirjaudu-ulos">Logout</a>
    <br />
    <a href="/auth/whoami">Profiili</a>
    <br />
  </div>
</template>
